import { Card, Icon, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../../shared/stores/RootStore";
import { AddIcon } from "../../../shared/views/icons";
import { buildCreateOrUpdateHlaLane, HlaLane } from "../../models/HlaLane";

const NewLaneButtonBase = ({
  frontFacing,
  canEdit,
}: {
  frontFacing: boolean;
  canEdit: boolean;
}) => {
  const { hlaStore } = useStores();

  if (!canEdit) return null;

  const directionKeys = ["frontFacingLane", "backFacingLane"];
  if (!frontFacing) {
    directionKeys.reverse();
  }
  const [directionKey, otherKey] = directionKeys;

  return (
    <Card.Root
      bgColor={"gray.100"}
      color={"gray.600"}
      h={"84px"}
      cursor={"pointer"}
      p={2}
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      alignSelf={"end"}
      mb={"48px"}
      onClick={() => {
        hlaStore.code((prev: any) => {
          const otherLane = prev[otherKey];
          return {
            ...prev,
            [directionKey]: otherLane
              ? copyLane(otherLane)
              : buildCreateOrUpdateHlaLane(frontFacing),
          };
        });
        hlaStore.setDefaultToFrontFacing(frontFacing);
      }}
    >
      <Icon as={AddIcon} />
      <Text fontSize={"xs"}>Add direction</Text>
    </Card.Root>
  );
};

export const NewLaneButton = observer(NewLaneButtonBase);

const copyLane = (other: HlaLane): HlaLane => {
  return {
    ...other,
    frontFacing: !other.frontFacing,
    adjacentFeaturesLeft: { ...other.adjacentFeaturesLeft },
    adjacentFeaturesRight: { ...other.adjacentFeaturesRight },
    score: null,
  };
};
